import { Component, Input, Output, EventEmitter, OnInit, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { PDFDocumentProxy, getDocument, PDFPageProxy } from 'pdfjs-dist';
import * as pdfjsLib from 'pdfjs-dist';

if (typeof (Promise as any).withResolvers !== 'function') {
  (Promise as any).withResolvers = () => {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
})
export class PdfViewerComponent implements OnInit, AfterViewInit {
  @Input() pdfSrc!: string;
  @Output() error = new EventEmitter<string>();
  @Output() afterLoadComplete = new EventEmitter<void>();

  @ViewChildren('pdfCanvas') pdfCanvasList!: QueryList<ElementRef<HTMLCanvasElement>>;

  pdfDoc: PDFDocumentProxy | null = null;
  totalPages = 0;
  pages: number[] = [];

  async ngOnInit() {
    // Set worker path on assets directory
    (pdfjsLib as any).GlobalWorkerOptions.workerSrc = '/assets/js/pdf.worker.min.mjs';

    if (this.pdfSrc) {
      await this.loadPdf(this.pdfSrc);
    }
  }

  private async loadPdf(src: string): Promise<void> {
    try {
      this.pdfDoc = await getDocument(src).promise;
      this.totalPages = this.pdfDoc.numPages;

      // Create array to render all the PDF pages
      this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

      // Emit afterLoadComplete event after successfully loading the PDF
      this.afterLoadComplete.emit();

      await this.renderAllPages();
    } catch (err) {
      // Emit error event with error message
      this.error.emit(`Failed to load PDF: ${err.message}`);
    }
  }

  async ngAfterViewInit() {
    // await this.renderAllPages();
  }

  private async renderAllPages(): Promise<void> {
    if (!this.pdfDoc) return;

    for (const pageNum of this.pages) {
      const page = await this.pdfDoc.getPage(pageNum);
      const canvas = this.pdfCanvasList.toArray()[pageNum - 1].nativeElement;
      const context = canvas.getContext('2d');
      const viewport = page.getViewport({ scale: 2 });

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: context!,
        viewport: viewport
      }).promise;
    }
  }
}
